import { ResultCode, TapResponseFrame } from '@iotize/tap/client/api';

export class TapResponseFrameBuilder {
  static SUCCESS(data?: Uint8Array): TapResponseFrame {
    return TapResponseFrameBuilder.create(ResultCode.OK, data);
  }

  static ERROR(
    status: number = ResultCode.BAD_REQUEST,
    data?: Uint8Array,
  ): TapResponseFrame {
    return TapResponseFrameBuilder.create(status, data);
  }

  static create(status: number, data?: Uint8Array): TapResponseFrame {
    return {
      status,
      data: data || new Uint8Array(),
    };
  }
}
